<template>
    <div class="facturation" style="padding:15px;">
        <h3>Création des factures brouillons</h3>
        <h5>Contrat Syntec</h5>
        <el-select v-model="syntec" placeholder="Syntec ?">
            <el-option
              label="Non"
              value="0">
            </el-option>
            <el-option
              label="Oui"
              value="1">
            </el-option>
        </el-select>
        <el-button type="primary" @click="createDraft">Création des brouillons</el-button>

        <h3>Importation des CDR</h3>
        <el-button type="primary" @click="downloadingCdr">Téléchargement des CDR</el-button>

        <h3>Valorisation des factures</h3>
        <el-button type="primary" @click="valorisation">Valorisation</el-button>

        <h3>Suppression des factures brouillons (Utiliser uniquement en dev)</h3>
        <el-button type="primary" @click="suppression">Suppression des brouillons</el-button>
    </div>
</template>

<script>
import scriptFacturation from '../../../../script/script_facturation.js'
function initValue(){
    return {
        fullscreenLoading: false,
        syntec: "0",
    }
}
export default {
  watch: {
  },
  props: {
  },
  created () {
  },
  data () {
    return initValue()
  },
  methods: {
      resetData(){
        Object.assign(this.$data, initValue())
      },
      downloadCdr: scriptFacturation.downloadCdr,
      createDraftInvoices: scriptFacturation.createDraftInvoices,
      valorisationInvoices: scriptFacturation.valorisation,
      async downloadingCdr(){
          const loading = this.$loading({
            lock: true,
            text: 'Chargement',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          if(await this.downloadCdr()){
              loading.close()
          }
      },
      async valorisation(){
        const loading = this.$loading({
            lock: true,
            text: 'Chargement',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
        if(await this.valorisationInvoices()){
            loading.close()
        }
      },
      async validateInvoices(){

      },
      async createDraft(){
        const loading = this.$loading({
            lock: true,
            text: 'Chargement',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
        if(await this.createDraftInvoices(this.syntec)){
            loading.close()
        }
      },
      async suppression(){
        const loading = this.$loading({
            lock: true,
            text: 'Chargement',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
        if(await scriptFacturation.deleteDraftInvoices()){
            loading.close()
        }
      }
  },

}
</script>

<style>
.facturation .el-step.is-horizontal{
  flex: auto;
}
</style>
